import React, { Component } from "react";
import Content from "../../content/Content";

export default class DisplayValidationErrors extends Component {
  render() {


      return (
      <React.Fragment>
        {this.props.errors && this.props.errors.length > 0 ? (

          
          <div className="alert alert-danger">
            <p className="alert-heading mb-1">
              <strong>{this.props.heading}</strong>
            </p>
            
            <ul className="mb-0 pl-4">
              {this.props.errors.map((message, index) => (
                <li key={index}>
                  <Content name={message} />
                </li>
              ))}
            </ul>
          </div>
        ) : (
          ""
        )}
      </React.Fragment>
    );
    

    
  }
}
